module.exports = __webpack_public_path__ + "static/sink-nav-0a1076c5f928fc821bfb823b0a39df52.jpeg";